import { tenantApi } from '@/modules/tenant/services/tenantApi';
import type {
  ApplyCreditNoteRequest,
  CreditNote,
  StoreCreditNoteRequest,
  VoidCreditNoteRequest,
} from '../types/service.types';

/**
 * D14-10: deliberately no update, no delete — credit notes are append-only;
 * a correction is a void plus a fresh note. Reverse-and-reissue mints its
 * `invoice_correction` note server-side (D16-28), so there is no client call for it here.
 */
export const creditNoteApi = {
  listForWorkOrder: (workOrderId: string) =>
    tenantApi.getList<CreditNote>(`/work-orders/${workOrderId}/credit-notes`),

  get: (id: string) => tenantApi.getOne<CreditNote>(`/credit-notes/${id}`),

  issue: (workOrderId: string, data: StoreCreditNoteRequest) =>
    tenantApi.postOne<CreditNote>(`/work-orders/${workOrderId}/credit-notes`, data),

  apply: (id: string, data: ApplyCreditNoteRequest) =>
    tenantApi.postOne<CreditNote>(`/credit-notes/${id}/apply`, data),

  void: (id: string, data: VoidCreditNoteRequest) =>
    tenantApi.postOne<CreditNote>(`/credit-notes/${id}/void`, data),

  listForCustomer: (customerId: string, status?: 'open' | 'all') =>
    tenantApi.getList<CreditNote>(`/customers/${customerId}/credit-notes`, {
      params: status ? { status } : undefined,
    }),
};
